import { render, staticRenderFns } from "./TargetV3.vue?vue&type=template&id=3d30a771&scoped=true&lang=pug&"
import script from "./TargetV3.vue?vue&type=script&lang=js&"
export * from "./TargetV3.vue?vue&type=script&lang=js&"
import style0 from "./TargetV3.vue?vue&type=style&index=0&id=3d30a771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d30a771",
  null
  
)

export default component.exports